/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Common filter properties for delivery notes across all roles
 */
export enum DeliveryNotesFilterProperties {
  Number = 'number',
  FileName = 'fileName',
  TourNumber = 'tourNumber',
  OrderNumber = 'orderNumber',
  ConsignorName = 'consignorName',
  CarrierName = 'carrierName',
  ConsigneeName = 'consigneeName',
  OriginalConsignor = 'originalConsignor',
  OriginalConsignorGln = 'originalConsignorGln',
  DeliveryNoteBundleNumber = 'deliveryNoteBundleNumber',
  Discrepancies = 'discrepancies',
  PalletTickets = 'palletTickets',
  DeliveryNoteBundleStatus = 'deliveryNoteBundleStatus',
  DateCreated = 'dateCreated',
  DateAnnounced = 'dateAnnounced',
  CheckoutDate = 'checkoutDate',
  CheckinDate = 'checkinDate',
  Properties = 'properties',
  PropertiesReferenceNumber = 'properties.referenceNumber',
  CarrierNumberPlateOutgoing = 'carrierNumberPlateOutgoing',
  Status = 'status'
}
